import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';

type Results = { generateTotpUri: string };

export const useGenerateTotpUri = (options?: QueryHookOptions<Results>) => {
  const query = gql`
    query generateTotpUri {
      generateTotpUri
    }
  `;

  return useLazyQuery(query, options);
};

export default useGenerateTotpUri;
